import { useEffect, useState } from 'react';
import { signalRService } from 'utils/signalr';
import { AskStreamMessage } from '../types';

export function useStreamedSteps(enabled: boolean) {
  const [streamedSteps, setStreamedSteps] = useState<string[]>([]);
  const [streamError, setStreamError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) {
      setStreamedSteps([]);
      setStreamError(null);
      return;
    }

    setStreamedSteps([]);
    setStreamError(null);

    const handleStreamMessage = (data: AskStreamMessage) => {
      if (data.eventName === 'error') {
        setStreamError(data.content);
        return;
      }
      setStreamedSteps([data.content]);
    };

    signalRService.subscribeEvent<AskStreamMessage>(
      'AskStreamMessage',
      handleStreamMessage,
    );

    return () => {
      signalRService.unsubscribeEvent('AskStreamMessage');
    };
  }, [enabled]);

  return { streamedSteps, streamError };
}
